import { Injectable } from '@angular/core';
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private dialogService: DialogService) { }

  public showNotification(message: string, confirm = false, attention = false): DynamicDialogRef {
    return this.dialogService.open(ConfirmDialogComponent, {
      showHeader: false,
      closable: false,
      width: '460px',
      data: {
        header: message,
        confirm: confirm,
        attention: attention
      },
      contentStyle: {
        'overflow': 'visible',
        'padding': '0',
        'background': 'transparent',
        'border-radius': '16px'
      },
      styleClass: 'custom-notification-dialog',
      maskStyleClass: 'custom-dialog-mask'
    });
  }
}
